import Axios from "axios";
import React from "react";
import { ArcGisMap, DataTable } from "../../../components";
import { ArcGisSearch } from "../../../components/map/search";
import { TYPE } from "../../../types";
import { downloadFile } from "../../../utils/download";
import { Button, CircularProgress } from "@material-ui/core";

interface InventoryProps {
  type: TYPE;
}

interface State {
  loading: boolean;
  data: any[];
  no: string;
  lampno: string;
}

const titles: Record<TYPE, string[]> = {
  lamppost: ["Inv", "_Fault", "_Anno", "_Mains"],
  lantern: ["Inv", "_Inspect"],
  bollard: ["Inv", "_Fault", "_Anno", "_Mains"],
  controller: ["Inv", "_Fault", "_Anno", "_Mains"],
  cable: ["Inv", "_Fault", "_Mains"],
  gsds: ["Inv", "_Fault", "_Lamp", "_Anno", "_Mains"],
  connector: ["Inv"],
  drawpit: ["Inv"],
};

export const Inventory: React.FC<InventoryProps> = (props) => {
  const { type } = props;

  const [state, setState] = React.useState<State>({
    data: [],
    loading: false,
    no: "",
    lampno: "",
  });

  const handleOnClick = (no: string) => {
    setState({ ...state, loading: true, no });
    Axios.get(`/${type}`, { params: { no } }).then((res) => {
      const { data } = res;
      setState({
        ...state,
        data,
        loading: false,
        no,
        lampno: no,
      });
    });
  };

  const handleOnClickDownloadButton = (no: string) => {
    setState({ ...state, loading: true});
    Axios.get(`/${type}/image`, { params: { no }})
      .then((res) => {
        setState({ ...state, loading: false});
        downloadFile(no + ".pdf", new Blob([new Uint8Array(res.data.data)], { type: "application/pdf" }));
      })
  };

  return (
    <>
      <div className="map">
        <ArcGisMap type={type} />
        <ArcGisSearch
          type={type}
          value={state.no}
          onChange={(value) => {
            setState({
              ...state,
              no: value,
            });
          }}
          onClick={handleOnClick}
        />
      </div>
      <div className="inventory lamppost">
        <h1>
          {state.lampno}
        </h1>
        {state.lampno && type == "lamppost"
          ?
            <>
              <Button
                variant="contained"
                onClick={(evt: any) => handleOnClickDownloadButton(state.lampno)}
                disabled={state.loading}
              >
                Download
                {
                  state.loading && (
                    <CircularProgress
                      size={24}
                      style={{
                        color: 'green',
                        textAlign: 'center',
                        position: 'absolute'
                      }}
                    />
                  )
                }
              </Button>
            </>
          : <></>}
        {state.data.map((row, index) => {
          return row.length > 0 ? (
            <DataTable
              title={titles[type][index]}
              columns={Object.keys(row[0]).map((key) => ({
                title: key,
                dataIndex: key,
              }))}
              data={row}
              key={index}
            />
          ) : (
            <table key={index}>
              <caption style={{ marginTop: "24px" }}>
                {titles[type][index]}
              </caption>
            </table>
          );
        })}
      </div>
    </>
  );
};
